import { AntiqueCondition, AntiquePurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  ant_type: {
    friendly: 'Antique Type',
    validations: {
      maxLength: 255,
    },
  },

  ant_maker: {
    friendly: 'Maker',
    validations: {
      maxLength: 255,
    },
  },

  ant_year_produced: {
    friendly: 'Year',
    validations: {
      type: 'integer',
    },
  },

  ant_medium: {
    friendly: 'Medium',
    validations: {
      maxLength: 255,
    },
  },

  ant_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 255,
    },
  },

  ant_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 255,
    },
  },

  ant_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 255,
    },
  },

  ant_inscriptions: {
    friendly: 'Inscriptions',
    validations: {
      maxLength: 255,
    },
  },

  ant_signature: {
    friendly: 'Signature',
    validations: {
      maxLength: 255,
    },
  },

  ant_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },

  ant_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: AntiqueCondition,
    },
  },

  ant_purchase_condition: {
    friendly: 'Purchase condition',
    validations: {
      type: 'enum',
      enumType: AntiquePurchaseCondition,
    },
  },

  ant_conservation_contact: {
    friendly: 'Conservation Contact',
    validations: {
      type: 'foreignKey',
    },
    typeHint: typeHints.Contact,
  },

  ant_conservation_type: {
    friendly: 'Conservation Type',
    validations: {
      maxLength: 255,
    },
  },

  ant_conservation_start_date: {
    friendly: 'Start Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  ant_conservation_end_date: {
    friendly: 'End Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  ant_conservation_cost: {
    friendly: 'Conservation Cost',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  ant_conservation_notes: {
    friendly: 'Conservation Notes',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },


};

export default attributes;

export const AntiqueDefaultSplitAttribute = 'ant_type';

export const AntiqueItemSearchAttributes = ['ant_type', 'ant_maker', 'ant_year_produced'];

export const AntiqueOverviewAttributes = ['title', 'ant_type', 'ant_maker', 'ant_year_produced', 'ant_country_of_origin', 'ant_condition', 'rarity',
  'market_value', 'quantity', 'inventory_no', 'tags'];

export const AntiqueSpecificationAttributes = ['ant_medium', 'ant_edition', 'ant_dimensions', 'ant_weight', 'ant_inscriptions', 'ant_signature'];

export const AntiquePurchaseAttributes = ['purchase_date', 'purchase_price', 'ant_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const AntiqueDetailAttributes = [];

export const AntiqueRequiredAttributes = [];

export const AntiqueDisplayAttributes = ['ant_type', 'ant_maker', 'ant_medium', 'ant_year_produced', 'ant_country_of_origin', 'tags'];

export const AntiqueSliderGalleryAttributes = {
  titleKey: 'ant_type',
  subtitleKey: 'ant_maker',
};



// WEBPACK FOOTER //
// ./src/config/antiqueDataAttributes.js